import { State, Module } from "app/decorators";
import BaseRoute from "app/routing";
import HitPercentageStore from "app/stores/hit_percentage";

import { HitPercentageListCtrl, HitPercentageCtrl } from "./ctrls";

import mainTpl from "./templates/main.html";
import detailTpl from "./templates/details.html";

import tableSectionTpl from "./templates/table.section.html";
import detailSectionTpl from "./templates/detail.section.html";

@Module({
  name: "app.admin.hit_percentages",
  modules: [BaseRoute, HitPercentageStore],
})
@State({
  name: "r.in.top.admin.hit_percentages",
  url: "/hit-percentages",
  template: mainTpl,
  ncyBreadcrumb: {
    skip: true,
  },
  abstract: ".list",
  data: {
    permissions: {
      only: ["main.view_user"],
    },
  },
})
@State({
  name: "r.in.top.admin.hit_percentages.list",
  url: "?search",
  views: {
    tableView: {
      template: tableSectionTpl,
      controller: HitPercentageListCtrl,
    },
    detailsView: {
      template: detailSectionTpl,
      controller: HitPercentageCtrl,
    },
  },
  resolve: {
    $object: function () {
      return null;
    },
  },
  ncyBreadcrumb: {
    label: "Hit Percentages for Forecasting",
  },
})
@State({
  name: "r.in.top.admin.hit_percentages.list.hit_percentage",
  url: "/{objectId:int}",
  ncyBreadcrumb: {
    skip: true,
  },
  template: "<ui-view/>",
  resolve: {
    $object: function ($stateParams, HitPercentageStore) {
      return HitPercentageStore.get($stateParams.objectId);
    },
  },
  abstract: ".detail",
})
@State({
  name: "r.in.top.admin.hit_percentages.list.hit_percentage.detail",
  url: "/details",
  controller: HitPercentageCtrl,
  template: detailTpl,
  ncyBreadcrumb: {
    label: "{{ vm.object.hit_percentage }}",
  },
})
export default class States {}



// WEBPACK FOOTER //
// ./src/app/admin/hit_percentages/routing.js